<template>
  <section class="upcoming-activity text-sm">
    <h2 class="flex justify-between items-center font-semibold text-xl tracking-normal section-header lg_text-2xl">
      <span>Upcoming Activity</span>
      <VLink v-if="activities.length > 0" class="text-copper-800 text-sm" :to="activitiesPath" data-testid="activities-more-button"
        >Show All</VLink
      >
    </h2>
    <div
      v-for="activity in displayActivities"
      :key="activity.id"
      class="flex flex-col justify-center relative w-full border border-gray-400 bg-white rounded-md py-3 pl-6 pr-12 my-4 h-24"
    >
      <div class="activity-name text-base">{{ activity.title }}</div>
      <div class="activity-details text-gray-600 font-normal">{{ activity.displayTime }}</div>
      <div class="activity-cta">
        <a v-if="activity.url" class="text-gray-900 underline" :href="activity.url" target="_blank">Learn More</a>
      </div>
      <div class="logo flex absolute right-6">
        <div class="h-5 w-5">
          <VCircleLogo v-if="activity.is_presented_with_vrify" class="h-full" />
        </div>
      </div>
    </div>
    <div
      v-if="someActivityPresentedWithVrify"
      class="flex justify-end items-center mt-6 text-gray-800"
      data-testid="presented-with-vrify-legend-key"
    >
      <p class="mr-2 mb-0 text-gray-400">Presented with VRIFY</p>
      <div class="h-5 w-5">
        <VCircleLogo class="w-full h-full" />
      </div>
    </div>
  </section>
</template>

<script lang="ts" setup>
import type { PropType, DeepReadonly } from 'vue'
import type { CompanyActivity } from '@/entities/companyActivity'
import { formatMeetingDuration } from '@/lib/datetime-format-utils'
import VCircleLogo from '@/components/icons/VCircleLogo.svg'

const props = defineProps({
  activities: {
    type: Array as PropType<DeepReadonly<CompanyActivity[]>>,
    required: true,
  },
})

const route = useRoute()

const displayActivities = computed(() => {
  return props.activities.map(activity => {
    const { start_date, start_time, end_date, end_time } = activity

    return {
      ...activity,
      displayTime: formatMeetingDuration(start_date, start_time, end_date, end_time),
    }
  })
})

const someActivityPresentedWithVrify = computed(() => props.activities.some(activity => activity.is_presented_with_vrify))

const activitiesPath = `${route.path}/activities`
</script>
